import { DEFAULT_PROFILE_PIC, PRO } from '../assets/icons';
import { Link } from 'react-router-dom';
import { Box, Tooltip } from '@mui/material';
import { Button } from '@wot/components';
import { useEffect, useState } from 'react';
import { ITrialClass, ITutor } from '@wot/typings';
import xhr from '../utils/fetch';
import { getAttendacePercentage } from '../utils/functions';
import { Laptop, Presentation } from 'lucide-react';

export default function   TutorCard({ item }: { item: ITutor }) {
  const name = item.personal.data.name;
  const profilePic = item.personal.data.profilePic;
  const categories = item.profession.data.categories;
  const [studentsCount, setStudentsCount] = useState(0);
  const [totalSessions, setTotalSessions] = useState<ITrialClass[]>([]);

  useEffect(() => {
    xhr({
      url: `/t/${item._id}/stats/students-count`,
      method: "GET"
    }).then(res => setStudentsCount(res.data.count || 0))
      .catch(err => err)
  }, []);

  // Total Sessions
  useEffect(() => {
    if (item?._id) {
      xhr({
        url: `/t/${item?._id}/sessions`,
        method: 'GET',
        params: {
          type: 'plan',
          status: 'completed'
        }
      })
        .then((res) => {
          if (res.status === 'OK') {
            setTotalSessions(res.data);
          }
        })
        .catch(() => { });
    }
  }, []);

  const [prevDesign/*, setPrevDesign*/] = useState(false);

  return (
    <>

    {prevDesign ? <Tooltip title={`Click on ${name}'s profile to view more details`} placement="top" arrow>
        <Link to={`/find-tutor/${item._id}`} state={item} className="w-full">
          <div className=" group flex flex-col border border-neutralGray3 m-2 p-2 rounded-lg cursor-pointer hover:bg-neutralBlue2">
            <div className="flex justify-end ">
              {item?.agreement?.level === 'premium' ? (
                <Tooltip title="Premium Tutor" arrow>
                  <img src={PRO} alt="Pro badge" className="h-7 w-7" />
                </Tooltip>
              ) : (
                <div className="h-7 w-7" />
              )}
            </div>
            <div className="flex flex-col gap-2 items-center py-4">
              <div className="flex flex-col items-center gap-1">
                <div className="h-28 w-28">
                  <img
                    src={profilePic === '' ? DEFAULT_PROFILE_PIC : profilePic}
                    alt="User Pic"
                    className="rounded-full h-28 w-28 object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="my-2">
                  <span className="text-xl font-medium">{name || `Ayesha`}</span>
                </div>
              </div>
              <div className="flex justify-center items-center divide-x">
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">{studentsCount}</span>
                  <span className="text-xs font-medium text-neutralGray2 text-center">Students</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">
                    {getAttendacePercentage(
                      totalSessions.filter((i) => i.attendance && i.attendance.student === 'present').length,
                      totalSessions.length
                    )}%
                  </span>
                  <span className="text-xs font-medium text-neutralGray2 text-center">Attendance</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  <span className="text-sm font-medium">
                    {item.experience.data.filter(i => i.type === "online").length}
                  </span>
                  <span className="text-xs font-medium text-neutralGray2">Online Exp.</span>
                </div>
                <div className="flex flex-col items-center px-1 text-center">
                  {item.experience.data.filter(i => i.type === "offline").length}
                  <span className="text-xs font-medium text-neutralGray2">Offline Exp.</span>
                </div>
              </div>
              <div className="flex justify-center flex-wrap py-2">
                {categories.map((item: any, i: any) => (
                  <span
                    className="rounded-full border bg-neutralBlue2 text-xs font-medium px-3 py-1 mx-1 mt-2 group-hover:bg-white"
                    key={i}
                  >
                    {item.name}
                  </span>
                ))}
              </div>
              <Link
                to={`/find-tutor/${item._id}`}
                state={item}
                className="flex w-full max-w-[150px] items-center justify-center"
              >
                <Button text="View details" type="secondary" onClick={() => { }} />
              </Link>
            </div>
          </div>
        </Link>
      </Tooltip>
      :
      <Tooltip title={`Click on ${name}'s profile to view more details`} placement="top" arrow>
        <Link to={`/find-tutor/${item._id}`} state={item} className="w-full relative">
<Box display="flex" justifyContent="center" alignItems="stretch" height="100%">
         <div className="group my-2 sm:my-4 rounded-lg cursor-pointer border border-neutralGray3 flex flex-col justify-between w-full max-w-sm mx-auto">
             <div className="flex justify-end absolute top-3 sm:top-5 right-3 sm:right-4 z-10">
              {item?.agreement?.level === 'premium' ? (
                <Tooltip title="Premium Tutor" arrow>
                  <img src={PRO} alt="Pro badge" className="h-6 w-6 sm:h-7 sm:w-7" />
                </Tooltip>
              ) : (
                <div className="h-6 w-6 sm:h-7 sm:w-7" />
              )}
            </div>
                <div className='relative'>
                     <div className='relative w-full h-64 sm:h-72 lg:h-64 rounded-t-lg overflow-hidden bg-gray-100'>
                      <img
                      src={profilePic === '' ? DEFAULT_PROFILE_PIC : profilePic}
                      alt={name}
                      className="w-full max-h-[400px] objec-contin transition-transform duration-300 group-hover:scale-105"
                      onError={(e) => {
                        e.currentTarget.src = DEFAULT_PROFILE_PIC;
                      }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent from-20% to-black/90"></div>
                     </div>
                     <div className='absolute bottom-2 sm:bottom-3 left-2 sm:left-4 right-2 sm:right-4 text-white font-bold'>
                    <span className="text-base sm:text-lg lg:text-xl capitalize block truncate">{FormatedName(name)}</span>
                     <div className='flex text-white items-center justify-start gap-2 sm:gap-4 mt-1'>
                      <div className="flex items-center gap-1 text-center">
                  <span className="text-xs sm:text-sm font-medium">
                    {item.experience.data.filter(i => i.type === "online").length} yr.
                  </span>
                  <span className="text-xs sm:text-sm"><Laptop className="w-3 h-3 sm:w-4 sm:h-4" /></span>
                </div>
                <div className="flex items-center gap-1 text-center">
                  {item.experience.data.filter(i => i.type === "offline").length} yr.
                  <span className="text-xs sm:text-sm"><Presentation className="w-3 h-3 sm:w-4 sm:h-4" /></span>
                </div>
                     </div>
                 </div>
                      
                </div>
                <div className="flex flex-wrap gap-1 sm:gap-2 py-2 sm:py-3 px-2 sm:px-4">
                {categories.slice(0, 3).map((item: any, i: any) => (
                  <span
                    className="rounded-full border bg-neutralBlue2 text-xs font-medium px-2 py-1 sm:px-3 sm:py-1 group-hover:bg-white transition-colors"
                    key={i}
                  >
                    {item.name}
                  </span>
                ))}
                {categories.length > 3 && (
                  <span className="rounded-full border bg-gray-100 text-xs font-medium px-2 py-1 sm:px-3 sm:py-1">
                    +{categories.length - 3}
                  </span>
                )}
              </div>
        
              <p className='px-3 sm:px-4 text-xs sm:text-sm text-gray-600 line-clamp-2 flex-grow'>
                {item.personal.data.bio ? item.personal.data.bio.slice(0, 70) + (item.personal.data.bio.length > 70 ? '...' : '') : 'No bio available'}
              </p>
              <div className='flex justify-center px-3 sm:px-4 py-3 sm:py-4'>
                
              <Link
                to={`/booktrail`}
                state={item}
                className="flex items-center justify-center w-full text-nowrap" >
                <Button 
                  text={`Book Free Trial with ${FormatedName(name)}`} 
                  type="primary" 
                  onClick={() => { }} 
                  className="w-full text-xs sm:text-sm capitalize py-2 sm:py-2.5"
                />
              </Link>
             
                </div>
                </div>
            </Box>
        </Link>
      </Tooltip>
    }
    </>
  );
}




const FormatedName = (name:string) => {
    const nameParts = name.split(' ');
    const firstInitial = nameParts[0] ? nameParts[0].charAt(0) : '';
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length-1] : '';
    const formattedName = `${firstInitial}. ${lastName}`;
  return formattedName;
}

